import type { TableSortState } from '../UI';

// The name column's sort key, shared because the default sort below has to
// point at the same column `getRoomColumns` renders. Nothing surfaces a
// mismatch: the table just renders unsorted under a header that still looks
// active, so this constant and the test beside it are the whole guard.
export const ROOM_NAME_COLUMN_KEY = 'name';

// Rooms arrived in creation order, so a room added later sat wherever it was
// created rather than where someone would look for it (REH-301). Ordering is
// Danish for every user; see SORT_LOCALE for why that is pinned rather than
// taken from the interface language.
export const DEFAULT_ROOMS_SORT: TableSortState = {
  key: ROOM_NAME_COLUMN_KEY,
  direction: 'asc'
};
